import { Injectable } from '@angular/core';
import { ApplicationConfigurationClientBase } from './application-configuration.client';
import { CookieService } from '@ngx-toolkit/cookie';
import {ClientVersion } from '../shared/core/ovs.core';

@Injectable()
export class UpdateClientService{
    constructor(private configService: ApplicationConfigurationClientBase, private cookieService:CookieService,){}
    public EnsureLatestVersion(callback: () => void):void{
        this.configService.GetClientVersion( (value: ClientVersion):void =>{
            var cookieClientVersion = this.cookieService.getItem("clientVersion");
            if( cookieClientVersion && cookieClientVersion != value.Version){
                alert("To better assist you and make sure you continue with a positive experience, we need to refresh this page to load the latest version of the resort store. Thank you for your patience.");
                window.location.reload();
            }
            else{
                if(callback) callback();
            }
        });
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/services/update-client.service.ts